import React from 'react';
import LoadingCircle from 'components/ui/LoadingCircle';
const Overlay = ({ text }) => {
    return (React.createElement("div", { className: "flex h-full w-full bg-green-200 opacity-75 absolute z-50" },
        React.createElement("div", { className: "mx-auto my-auto" },
            React.createElement(LoadingCircle, { text: text }))));
};
export default Overlay;
